import Enhancer from '../enhancer.js';
import EnhancerApp from '../enhancer-app.js';

export default class Filter extends Enhancer {

    init() {

        this.getAll('.filter-reset-btn').forEach((resetBtn) => {
            resetBtn.addEventListener('click', this.resetFilter.bind(this));
        });

        this.getAll('input[type=checkbox]').forEach((checkbox) => {
            checkbox.addEventListener('click', this.toggleResetButton.bind(this));
        });

    }

    toggleResetButton(e) {
        const filterGroup = e.target.name;
        const anyChecked = Array.from(this.getAll(`input[name=${filterGroup}]`))
            .some(checkbox => checkbox.checked);

        this.get(`button[data-group=${filterGroup}]`).classList.toggle('d-none', !anyChecked);
    }

    resetFilter(e) {
        e.preventDefault();

        const filterGroup = e.target.getAttribute('data-group');

        this.getAll(`input[name=${filterGroup}]`).forEach(checkbox => { checkbox.checked = false; });

        e.target.classList.add('d-none');
    }
}

EnhancerApp.register('Filter', Filter);